import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QUERY_KEYS } from '~constants'
import { getOfferDetailsRequest } from '~services'
import { OfferDetailsResponse, OfferDetailsInput } from '~types/offer'
import { QueryKey } from '~utils'

const { OFFER_DETAILS } = QUERY_KEYS

export function useGetOfferDetails(
  variables: OfferDetailsInput,
  options?: UseQueryOptions<OfferDetailsResponse, unknown, OfferDetailsResponse>
) {
  const offerDetailsQueryKey: QueryKey = [OFFER_DETAILS, variables]

  const {
    isLoading: isLoadingOfferDetails,
    refetch: refetchOfferDetails,
    data: offerDetails,
  } = useQuery<OfferDetailsResponse>(
    offerDetailsQueryKey,
    () => getOfferDetailsRequest(variables),
    {
      ...options,
    }
  )

  return {
    isLoadingOfferDetails,
    offerDetails: offerDetails?.offer,
    refetchOfferDetails,
  }
}

useGetOfferDetails.queryKey = (variables: OfferDetailsInput): QueryKey => [OFFER_DETAILS, variables]
